import React, { useState, useEffect, useContext, useRef } from "react";
import {
  onImageError,
  onPropertyImageError,
  numberWithCommas,
  setDecimalPoint,
} from "../../../utils";
import PropertyImageGallery from "./PropertyImageGallery";
import PaymentCalculator from "./PaymentCalculator";
import * as CronofyElements from "cronofy-elements";
import "./scheduleTour.css";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import PropertyTimePopup from "./ProprtyTimePopup";
import axios from "axios";
import { getLocation } from "../../../API/userData";
import {
  getAvailability,
  getAvailSlots,
  getPrivateBlock,
  getBidHistory,
  getOfferHistory,
  getOpenBookingBlock,
  getNewToken,
  getPropertyDetails,
} from "../../../API/propertyDetails";
import moment from "moment";
import { toast } from "react-toastify";
import isAuthenticate from "../../../utils/auth";
import { useHistory, useLocation } from "react-router-dom";
import GlobalContext from "../../../context/GlobalContext";
import Tooltip from "@material-ui/core/Tooltip";
import SearchMap from "../Search/SearchMap";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Markup } from "interweave";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
} from "@material-ui/core";
import CustomDialog from "../../atoms/CustomDialog";
import PropertyLocation from "./PropertyLocation";

const useStyles = makeStyles((theme) => ({
  customFontSize: {
    fontSize: "13px",
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const PropertyLeftShow = ({
  data,
  matterport,
  showMatterport,
  userValue,
  lable,
  width,
  bookTour,
  currentPropCity,
  constructAddressComponent,
  bidHistory,
  mobWidth,
}) => {
  const openNewWindow = (path) => window.open(path, "_blank");
  const [value, setValue] = React.useState(0);
  const [viewPropertyLocations, setViewPropertyLocations] = useState([]);
  const [availableSlots, setAvailableSlots] = useState({});
  const [availOpenSlots, setAvailOpenSlots] = useState({});
  const [isImageLoaded, setIsImageLoaded] = useState([]);
  const [slotPopup, setSlotPopup] = useState(false);
  const [selectedSlot, setSelectedSlot] = useState({});
  const [agentEmail, setAgentEmail] = useState("");
  const [drawSearch, setDrawSearch] = useState(false);
  const [isBoundSet, setIsBoundSet] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState({});
  const [propertyLoc, setPropertyLoc] = useState([]);
  const [mobileSelectedPropertyId, setMobileSelectedPropetyId] = useState("");
  const [mobilePropertyPopupOpen, setMobilePropertyPopupOpen] = useState(false);
  const imgRef = useRef(null);
  const [bidHistoryModal, setBidHistoryModal] = useState(false);
  const [offerHistoryModal, setOfferHistoryModal] = useState(false);
  const [propertyDet, setPropertyDet] = useState({});
  const [offerHistoryData, setOfferHistoryData] = useState({});
  const location = useLocation();
  const history = useHistory();
  const { userLoggedIn, userDetails, headerLocation, storeDetails } =
    useContext(GlobalContext);
  const isMounted = useRef(true);

  useEffect(() => {
    isMounted.current = true;

    return () => {
      isMounted.current = false;
    };
  }, []);

  const slotOpenPopup = () => {
    setSlotPopup(true);
  };
  const slotClosePopup = () => {
    setSlotPopup(false);
  };

  const classes = useStyles();

  // useEffect(() => {
  //   propertyLocation();
  // }, [storeDetails]);

  const store_id = window.location.pathname.split("/")[1];
  const site_id = localStorage.getItem("site_id");

  const propertyLocation = () => {
    getLocation(site_id)
      .then((data) => {
        if (isMounted.current && data && data.length > 0) {
          setPropertyLoc(data);
        }
      })
      .catch((err) => {
        if (isMounted.current) {
          console.error("Error fetching property location:", err);
        }
      });
  };
  const privateCalendarCall = () => {
    let availCronSlotOpen = {
      id: data.id,
      type: 0,
    };

    getCronAvailForProd(availCronSlotOpen)
      .then((res) => {
        if (
          isMounted.current &&
          res &&
          res.status &&
          res.data &&
          typeof res.data !== "undefined"
        ) {
          let todaysDate = new Date();
          let today = moment(todaysDate);
          let seventhDaysDate = new Date();
          seventhDaysDate.setDate(todaysDate.getDate() + 6);
          let seventhDate = moment(seventhDaysDate);
          let arrayOfDates = getDatesBetweenDates(today, seventhDate).map(
            (ele) => moment(ele).format("MM/DD/YYYY").toString(),
          );

          let objCron = {};
          for (let i = 0; i < arrayOfDates.length; i++) {
            objCron[arrayOfDates[i]] = [];
          }
          for (let j = 0; j < res.data.length; j++) {
            let dataArr = res.data[j];
            for (let i = 0; i < dataArr.available_periods.length; i++) {
              if (
                Object.keys(objCron).includes(
                  moment(dataArr.available_periods[i].start)
                    .format("MM/DD/YYYY")
                    .toString(),
                )
              ) {
                objCron[
                  moment(dataArr.available_periods[i].start).format(
                    "MM/DD/YYYY",
                  )
                ].push(dataArr.available_periods[i]);
              }
            }
          }
          setAvailableSlots(objCron);
        }
      })
      .catch((err) => {
        if (isMounted.current) {
          console.error("Error fetching available slots:", err);
        }
      });
  };

  const handleChange = (event, newValue) => {
    setValue(Number(newValue));
    if (Number(newValue) === 0) {
      privateCalendarCall();
    } else if (Number(newValue) === 1) {
      let availCronSlotOpen = {
        id: data.id,
        type: 1,
      };

      getCronAvailForProd(availCronSlotOpen)
        .then((res) => {
          if (
            isMounted.current &&
            res &&
            res.status &&
            res.slots &&
            typeof res.slots !== "undefined"
          ) {
            let todaysDate = new Date();
            let today = moment(todaysDate);
            let seventhDaysDate = new Date();
            seventhDaysDate.setDate(todaysDate.getDate() + 6);
            let seventhDate = moment(seventhDaysDate);
            let arrayOfDates = getDatesBetweenDates(today, seventhDate).map(
              (ele) => moment(ele).format("MM/DD/YYYY"),
            );

            let _objCron = {};
            for (let i = 0; i < arrayOfDates.length; i++) {
              _objCron[arrayOfDates[i]] = [];
            }

            for (let i = 0; i < res.slots.length; i++) {
              if (
                Object.keys(_objCron).includes(
                  moment(res.slots[i].start).format("MM/DD/YYYY"),
                )
              ) {
                _objCron[moment(res.slots[i].start).format("MM/DD/YYYY")].push(
                  res.slots[i],
                );
              }
            }

            setAvailOpenSlots(_objCron);
          }
        })
        .catch((err) => {
          if (isMounted.current) {
            console.error("Error getting available slots:", err);
          }
        });
    }
  };

  // const blockedSlot = () => {
  //   if (Number(value) === 0) {
  //     onIndividualPrivateSlot(selectedSlot);
  //   } else if (Number(value) === 1) {
  //     onIndividualOpenSlot(selectedSlot);
  //   }
  // };

  const selectedSlots = (selSlot) => {
    if (Number(value) === 0) {
      if (isAuthenticate() !== undefined) {
        if (!(userDetails.get["id"] === data.user_id)) {
          setSelectedSlot(selSlot);
          setSlotPopup(true);
        } else {
          toast.warning("Can't book your own property time slot");
        }
      } else {
        history.push(`/login`);
      }
    } else if (Number(value) === 1) {
      if (userDetails.get["id"] === data.user_id) {
        toast.warning("Can't book your own property time slot");
      } else {
        if (isAuthenticate() !== undefined) {
          setSelectedSlot(selSlot);
          onIndividualOpenSlot(selSlot);
        } else {
          setSelectedSlot(selSlot);
          setSlotPopup(true);
        }
      }
    }
  };

  const agentEmailAddressChng = (value, radioValue) => {
    setAgentEmail(value);
  };
  const getCronAvailForProd = (cronAvail) => {
    return getAvailSlots(cronAvail, site_id)
      .then((data) => {
        return data;
      })
      .catch((error) => {
        if (isMounted.current) {
          console.error("Error getting available slots:", error);
        }
        throw error;
      });
  };
  const getDatesBetweenDates = (startDate, endDate) => {
    let dates = [];
    const theDate = new Date(startDate);
    while (theDate < endDate) {
      dates = [...dates, new Date(theDate)];
      theDate.setDate(theDate.getDate() + 1);
    }
    dates = [...dates, endDate];
    return dates;
  };
  const onIndividualOpenSlot = (invSlot) => {
    let params = {
      slot: invSlot,
    };
    let propertyDtls = {
      id: data.id,
      email:
        isAuthenticate() !== undefined ? userDetails.get.email : agentEmail,
    };

    getNewToken(site_id)
      .then((data__) => {
        if (isMounted.current && data__.status) {
          return getOpenBookingBlock(propertyDtls, params, site_id);
        }
        return null;
      })
      .then((data_) => {
        if (isMounted.current && data_ && data_.status) {
          toast.success("Open houses slot has been booked successfully");
          setSlotPopup(false);
        }
      })
      .catch((err) => {
        if (isMounted.current) {
          console.error("Error booking open slot:", err);
        }
      });
  };
  const onIndividualPrivateSlot = (invSlot) => {
    let params = {
      slot: encodeURI(JSON.stringify(invSlot)),
    };
    let propertyDtls = {
      id: data.id,
      agentEmail:
        agentEmail && agentEmail.length > 0
          ? agentEmail
          : userDetails.get.email,
    };

    getNewToken(site_id)
      .then((data__) => {
        if (isMounted.current && data__.status) {
          return getPrivateBlock(propertyDtls, params, site_id);
        }
        return null;
      })
      .then((data_) => {
        if (isMounted.current && data_ && data_.status) {
          setSlotPopup(false);
          toast.success("Private tour slot has been booked successfully");
          privateCalendarCall();
          setAgentEmail("");
        } else if (isMounted.current && data_) {
          toast.error(data_.message);
          setSlotPopup(false);
          setAgentEmail("");
        }
      })
      .catch((err) => {
        if (isMounted.current) {
          console.error("Error booking private slot:", err);
        }
      });
  };
  useEffect(() => {
    if (
      data &&
      Object.keys(data).length > 0 &&
      typeof data !== "undefined" &&
      window.google &&
      window.google.maps
    ) {
      let singleProperty = {
        id: data.id,
        city: data.loc_city,
        state: data.state,
        latlng: new window.google.maps.LatLng(
          Number(data.lat),
          Number(data.lng),
        ),
      };
      setViewPropertyLocations([singleProperty]);
      if (imgRef.current?.complete) {
        setIsImageLoaded(new Array(matterport.length).fill(true));
      }
    }
  }, [data, window.google]);
  // useEffect(() => {
  //   if (data && Object.keys(data).length > 0 && typeof data !== "undefined") {
  //     privateCalendarCall();
  //   }
  // }, [data]);
  useEffect(() => {
    if (location && location.search) {
      let url = new URLSearchParams(location.search);
      let pathnames = location.pathname.split("/");
      let urlValue = {};
      urlValue["lat"] = url.get("lat");
      urlValue["lng"] = url.get("long");
      urlValue["cities"] = url.get("cities");
      urlValue["state"] = url.get("state");
      urlValue["radius"] = url.get("radius");
      if (
        url.get("north") &&
        url.get("south") &&
        url.get("east") &&
        url.get("west")
      ) {
        setIsBoundSet(true);
      } else {
        setIsBoundSet(false);
      }
      setSelectedLocation(urlValue);
    }
  }, [location]);

  const handleMapCenterChange = (newCenter, newBound) => {
    let url = new URLSearchParams(location.search);
    url.set("north", newBound.north);
    url.set("south", newBound.south);
    url.set("east", newBound.east);
    url.set("west", newBound.west);
    url.set("lat", newCenter.lat);
    url.set("long", newCenter.lng);
    url.set("cities", "");
    url.set("state", "");
    history.replace({
      pathname: location.pathname,
      search: "?" + url.toString(),
    });
    headerLocation.set({
      id: "",
      cities: "",
      state: "",
      lat: "",
      lng: "",
    });
  };

  const getPropertyData = (id) => {
    getPropertyDetails(data?.id, site_id)
      .then((prodData) => {
        if (isMounted.current && prodData.status === true) {
          setPropertyDet(prodData.result);
        }
      })
      .catch((err) => {
        if (isMounted.current) {
          console.error("Error fetching property details:", err);
        }
      });
  };

  const fetchOfferHistory = () => {
    getOfferHistory({ id: data?.id + "" }, site_id)
      .then((offerResult) => {
        if (isMounted.current && offerResult.status === true) {
          if (offerResult.result.length) {
            let dataOffer = offerResult.result.filter(
              (data) => data.user_id === userDetails.get["id"],
            );
            setOfferHistoryData(dataOffer);
          } else {
            setOfferHistoryData([]);
          }
        }
      })
      .catch((err) => {
        if (isMounted.current) {
          console.error("Error fetching offer history:", err);
        }
      });
  };

  const handleOfferHistory = () => {
    setOfferHistoryModal(true);
    fetchOfferHistory();
  };

  // useEffect(() => {
  //   getPropertyData();
  // }, [data?.id, site_id]);

  return (
    <>
      <div className="pv-left-top">
        <div className="propertyDescription my-4">
          {data?.occupancy_status === "occupied" && (
            <div className="notice-disclaimer">
              <span className="disclaimer-title">Occupied Disclaimer:</span>
              <span className="disclaimer-text">
                {" "}
                This property is currently occupied. No interior access or
                showings will be permitted under any circumstances. The property
                is being sold strictly in "AS-IS" condition, with no
                representations or warranties regarding its condition or
                occupancy status. The buyer shall assume full responsibility for
                addressing the occupancy after closing. All parties are advised
                to respect the rights of the occupants and refrain from any
                direct contact or disturbance.
              </span>
            </div>
          )}
          {data?.cash_only_flag == 1 && (
            <div className="notice-disclaimer cashonly">
              <span className="disclaimer-title">Cash Only:</span>
              <span className="disclaimer-text">
                {" "}
                Conventional financing is NOT accepted for this property. See
                disclosures for further info.
              </span>
            </div>
          )}
          {data?.description ? (
            <Accordion
              className="my-4"
              expanded={data.description ? true : false}
            >
              <AccordionSummary>Description</AccordionSummary>
              <AccordionDetails>
                <Markup content={data.description} />
              </AccordionDetails>
            </Accordion>
          ) : null}
          {data?.auction_disclosures ? (
            <Accordion
              className="my-4"
              expanded={data.auction_disclosures ? true : false}
            >
              <AccordionSummary>Auction Disclosures</AccordionSummary>
              <AccordionDetails>
                <div
                  dangerouslySetInnerHTML={{ __html: data.auction_disclosures }}
                />
              </AccordionDetails>
            </Accordion>
          ) : null}
          {data?.property_disclosures ? (
            <Accordion
              className="my-4"
              expanded={data.property_disclosures ? true : false}
            >
              <AccordionSummary>Property Disclosures</AccordionSummary>
              <AccordionDetails>
                <Markup content={data.property_disclosures} />
              </AccordionDetails>
            </Accordion>
          ) : null}
        </div>

        {mobWidth ? (
          <PropertyLocation
            data={data}
            currentPropCity={currentPropCity}
            width={width}
          />
        ) : (
          <></>
        )}

        <PaymentCalculator data={data} isDraw={drawSearch} />
      </div>

      {slotPopup ? (
        <PropertyTimePopup
          open={slotPopup}
          onClose={slotClosePopup}
          selectSlot={selectedSlot}
          data={data}
          seletedTab={value}
          setEmailAddressChng={agentEmailAddressChng}
          agentEmailAdd={agentEmail}
          onClickConfirmTour={blockedSlot}
        />
      ) : null}

      <CustomDialog
        title="Bid History"
        open={bidHistoryModal}
        dialogClass="bidHistoryModal"
        handleClose={() => setBidHistoryModal(false)}
      >
        <table className="table">
          <thead>
            <tr>
              <th>Username</th>
              <th>Date</th>
              <th>Proposed amount</th>
            </tr>
          </thead>
          <tbody>
            {bidHistory?.length ? (
              <>
                {bidHistory?.map((data, index) => (
                  <tr key={index}>
                    <td>{data.username}</td>
                    <td>
                      {moment(data.created_at).format("MMM DD")} at{" "}
                      {moment(data.created_at).format("hh:mm A")}
                    </td>
                    <td>
                      {data.proposed_amount
                        ? `$${setDecimalPoint(
                            parseInt(data.proposed_amount, 10),
                          )}`
                        : "-"}
                    </td>
                  </tr>
                ))}
              </>
            ) : (
              <tr>
                <td colSpan={5} className="text-center">
                  No records found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </CustomDialog>

      <CustomDialog
        title="Offer History"
        open={offerHistoryModal}
        dialogClass="bidHistoryModal"
        handleClose={() => setOfferHistoryModal(false)}
      >
        <table className="table">
          <thead>
            <tr>
              <th>Username</th>
              <th>Date</th>
              <th>Proposed amount</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {offerHistoryData?.length ? (
              <>
                {offerHistoryData?.map((data, index) => (
                  <tr key={index}>
                    <td>{data.username}</td>
                    <td>
                      {moment(data.created_at).format("MMM DD")} at{" "}
                      {moment(data.created_at).format("hh:mm A")}
                    </td>
                    <td>
                      {data.proposed_amount
                        ? `$${setDecimalPoint(
                            parseInt(data.proposed_amount, 10),
                          )}`
                        : "-"}
                    </td>
                    <td>
                      {data.offer_status == "declined"
                        ? "Declined"
                        : data.offer_status == "new"
                          ? "Pending"
                          : "Accepted"}
                    </td>
                  </tr>
                ))}
              </>
            ) : (
              <tr>
                <td colSpan={5} className="text-center">
                  No records found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </CustomDialog>
    </>
  );
};

export default PropertyLeftShow;
